import { z } from "zod";

export const SearchDataSchema = z.object({
	count: z.union([z.number(), z.string()]),
	query: z.string(),
	results: z.array(
		z.object({
			blurb: z.string(),
			image: z.string(),
			permalink: z.string(),
			price: z.string(),
			title: z.string(),
			type: z.string(),
		}),
	),
});
export type IResponseData = z.infer<typeof SearchDataSchema>;
export type ISingleResult = IResponseData["results"][number];
